import { render, staticRenderFns } from "./dispatch-info.vue?vue&type=template&id=e6578cbc&scoped=true&"
import script from "./dispatch-info.vue?vue&type=script&lang=js&"
export * from "./dispatch-info.vue?vue&type=script&lang=js&"
import style0 from "./dispatch-info.vue?vue&type=style&index=0&id=e6578cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6578cbc",
  null
  
)

export default component.exports